export default "skymp5-front/c1aa44800eaab2708600c244af65efb4.mp3";